import type { IAuthRepository } from '@src/domain/users/repository';
import type { AuthTokens } from '@src/domain/users/value_objects';
import { authTokens } from '@src/infrastructure/api/client';

/**
 * Refresh Token Use Case
 * Handles refreshing the access token
 */
export class RefreshTokenUseCase {
    constructor(private readonly authRepository: IAuthRepository) { }

    async execute(refreshToken: string): Promise<AuthTokens> {
        const tokens = await this.authRepository.refreshToken(refreshToken);

        // Update tokens in localStorage
        authTokens.setAccessToken(tokens.accessToken);
        authTokens.setRefreshToken(tokens.refreshToken);

        return tokens;
    }
}
